<template>
  <v-data-table
    :headers="headers"
    :items="ftpUsers"
    :items-per-page="20"
    :items-per-page-options="footerOptions['items-per-page-options']"
    :loading="fetching"
    class="elevation-0"
  >
    <template v-slot:loader>
      <v-row class="ftp-users-loading-spinner">
        <v-col class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="primary" :aria-label="$t('console.ftpUsersLoadingList')" />
          <div>{{ $t('console.ftpUsersLoadingList') }}</div>
        </v-col>
      </v-row>
    </template>

    <template v-slot:no-data>
      <v-row class="ftp-users-no-results">
        <v-col class="text-center">
          <div>{{ $t('console.ftpUsersNoFtpUsersFound') }}</div>
        </v-col>
      </v-row>
    </template>

    <template v-slot:header.actions>
      <div style="text-align: right;">
        <v-btn
          color="primary"
          size="small"
          data-cy="console-ftpUsers-add"
          elevation="0"
          @click="onAddUser"
        >
          {{ $t('console.ftpUsersAddUser') }}
        </v-btn>
      </div>
    </template>

    <template v-slot:item.user="{ item }">
      <div class="d-flex flex-column">
        <span class="font-weight-bold">{{ item.user?.name || '-' }}</span>
        <span class="text-caption text-grey">{{ item.user?.email || '-' }}</span>
      </div>
    </template>

    <template v-slot:item.username="{ item }">
      <div>{{ item.username || '-' }}</div>
    </template>

    <template v-slot:item.createdAt="{ item }">
      <div>{{ formatDate(item.createdAt) }}</div>
    </template>

    <template v-slot:item.node.name="{ item }">
      <div>
        <span v-if="item.node">
          <router-link :to="`/node/${item.node.id}`">
          {{ item.node.name }}
          </router-link>
        </span>
        <span v-else>-</span>
      </div>
    </template>

    <template v-slot:item.actions="{ item }">
      <div style="text-align: right;">
        <v-btn icon variant="text" :data-cy="`console-ftpUsers-edit-${item.id}`" @click="onEdit(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon variant="text" :data-cy="`console-ftpUsers-delete-${item.id}`" @click="onDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </template>

    <template v-slot:footer>
      <v-data-table-footer
        :items-per-page-options="footerOptions['items-per-page-options']"
        style="font-size: 10px;"
      />
    </template>

  </v-data-table>

  <FTPUserCreateDialog
    v-model="showCreateDialog"
    @created="$emit('refresh'); $emit('created')"
  />

  <FTPUserUpdateDialog
    v-model="showUpdateDialog"
    :ftp-user="selectedFtpUser"
    @updated="$emit('refresh')"
  />

  <FTPUserDeleteDialog
    v-model="showDeleteDialog"
    :ftp-user="selectedFtpUser"
    @deleted="$emit('refresh')"
  />
</template>

<script>
import FTPUserCreateDialog from './dialogs/FTPUserCreateDialog.vue';
import FTPUserUpdateDialog from './dialogs/FTPUserUpdateDialog.vue';
import FTPUserDeleteDialog from './dialogs/FTPUserDeleteDialog.vue';
import { formatDate } from '@/components/formatters.js';

export default {
  name: 'FTPUsersListView',
  emits: ['refresh', 'created'],
  components: {
    FTPUserCreateDialog,
    FTPUserUpdateDialog,
    FTPUserDeleteDialog,
  },
  props: {
    ftpUsers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fetching: false,
      showCreateDialog: false,
      showUpdateDialog: false,
      showDeleteDialog: false,
      selectedFtpUser: null,
      headers: [
        { title: this.$t('console.ftpUsersFtpUsername'), key: 'username' },
        {
          title: this.$t('console.ftpUsersUser'),
          key: 'user',
          value: (item) => item.user?.name || '',
        },
        { title: this.$t('console.ftpUsersFolder'), key: 'node.name' },
        { title: this.$t('console.ftpUsersCreatedAt'), key: 'createdAt' },
        { title: '' /*this.$t('console.ftpUsersActions')*/, key: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    formatDate,
    onEdit(item) {
      this.selectedFtpUser = item;
      this.showUpdateDialog = true;
    },
    onDelete(item) {
      this.selectedFtpUser = item;
      this.showDeleteDialog = true;
    },
    onAddUser() {
      this.showCreateDialog = true;
    },
  },
  computed: {
    // keep footer options consistent
    footerOptions() {
      return {
        'items-per-page-options': [20, 30, 50, 100],
      };
    },
  }
}
</script>

<style>
.ftp-users-list-view-header-row {
  font-weight: 600;
  cursor: pointer;
  height: 54px;
  color: #000000;
  background-color: #3dabff;
  border-radius: 10px;
  align-items: center;
}

.ftp-users-list-view-row { padding-left: 8px; padding-right: 8px; display: flex; }
.ftp-users-list-view-row > div { display: flex; align-items: center; padding: 0 12px; }
.ftp-users-list-view-row > div:nth-child(1) { width: 20%; }
.ftp-users-list-view-row > div:nth-child(2) { width: 25%; word-wrap: break-word; }
.ftp-users-list-view-row > div:nth-child(3) { width: 20%; }
.ftp-users-list-view-row > div:nth-child(4) { width: 25%; }
.ftp-users-list-view-row > div:nth-child(5) { width: 10%; justify-content: end; }

.ftp-users-loading-spinner { padding-top: 24px; }
</style>
